import { MapUtil } from "@/api/app.js";
import { queryCom } from "@/api/attendance.js";
class LocationService {
  constructor() {
    // 确保只能创建一个实例
    if (LocationService.instance) {
      return LocationService.instance;
    }

    // 缓存实例
    LocationService.instance = this;
  }
  // 高德start
  // 计算两点之间的距离
  calculateDistance(startLat, startLng, endLat, endLng) {
    return new Promise((resolve, reject) => {
      try {
        // 检查高德地图API是否存在
        if (typeof AMap === 'undefined') {
          throw new Error('高德地图API未正确加载');
        }

        // 加载Driving插件
        AMap.plugin('AMap.Driving', () => {
          // 构造路线导航类
          const driving = new AMap.Driving({
            policy: 0,//速度优先，此路线不一定距离最短
          });

          // 起点和终点
          const startPoint = [startLng, startLat]; // [lng, lat]
          const endPoint = [endLng, endLat]; // [lng, lat]

          // 进行驾车路线规划
          driving.search(startPoint, endPoint, (status, result) => {
            console.log('获取驾车路线结果:', status, result);
            if (status === 'complete' && result.routes && result.routes.length > 0) {
              // 获取第一条路线（最优路线）
              const route = result.routes[0];
              // 路线距离，单位为米
              const distanceInMeters = route.distance;
              // 转换为公里并保留两位小数
              const distanceInKilometers = parseFloat((distanceInMeters / 1000).toFixed(2));

              resolve(distanceInKilometers); // 返回单位为公里的距离值
            } else {
              console.error('获取驾车路线失败:', result);
              resolve(-1); // 返回错误标识
            }
          });
        });
      } catch (error) {
        console.error('计算驾车距离失败:', error);
        resolve(-1); // 返回错误标识
      }
    });
  }
  distance(startLat, startLng, endLat, endLng){
    try {
      // 检查高德地图API是否存在
      if (typeof AMap === 'undefined' || !AMap.GeometryUtil) {
        throw new Error('高德地图API未正确加载');
      }

      // 使用高德地图计算两点间距离
      const distanceInMeters = AMap.GeometryUtil.distance(
        [startLng, startLat],  // 起点经纬度 [lng, lat]
        [endLng, endLat]       // 终点经纬度 [lng, lat]
      );

      // 转换为公里并保留两位小数
      const distanceInKilometers = parseFloat((distanceInMeters / 1000).toFixed(2));

      return distanceInKilometers;  // 返回单位为公里的距离值
    } catch (error) {
      console.error('计算距离失败:', error);
      return -1;  // 返回错误标识
    }
  }
  // 高德end
  baiduLocation() {
    return new Promise((resolve, reject) => {
      const geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        (r) => {
          console.log('获取位置', geolocation.getStatus(), r);
          if (geolocation.getStatus() === BMAP_STATUS_SUCCESS) {
            resolve(r); // 成功时返回位置信息
          } else {
            reject(new Error('获取位置失败，请检查定位权限是否开启')); // 失败时返回错误
          }
        },
        { enableHighAccuracy: true }
      );
    });
  }
  
  async getCurrentLocation(){
    try {
      // 检查定位权限
      const hasLocationPermission = await MapUtil.getPermissions('LOCATION');
      if (!hasLocationPermission) {
        throw new Error('定位权限未开启');
      }

      // 获取当前位置
      const position = await this.baiduLocation();
      return position;
    } catch (error) {
      console.error('获取位置信息失败:', error);
      throw error;
    }
  }
  
  // 根据经纬度获取城市信息和区域码
  async getCityInfoByLocation(longitude, latitude) {
    return new Promise((resolve, reject) => {
      try {
        const geocoder = new BMap.Geocoder();
        const point = new BMap.Point(longitude, latitude);
        
        geocoder.getLocation(point, async (result) => {
          if (result) {
            const cityName = result.addressComponents.city;
            const areaCode = await this.getAreaCodeByCityName(cityName);
            resolve({
              cityName: cityName,
              areaCode: areaCode,
              fullAddress: result.address,
              addressComponents: result.addressComponents
            });
          } else {
            reject(new Error('无法获取位置信息'));
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  
  // 根据城市名获取区域码
  async getAreaCodeByCityName(cityName) {
    try {
      // 从缓存中获取地市列表
      let cityList = JSON.parse(localStorage.getItem('result'));
      if (!cityList) {
        // 如果缓存中没有，则调用接口获取
        let params = { body: { provincecode: '' } };
        cityList = await queryCom(params);
        localStorage.setItem('result', JSON.stringify(cityList));
      }
      
      // 查找匹配的城市并返回区域码
      if (cityList.errcode == '0') {
        for (let province of cityList.data) {
          for (let city of province.children) {
            // 去掉市字进行比较，如"北京市"与"北京"
            if (city.name.replace('市', '') === cityName.replace('市', '')) {
              return city.code;
            }
          }
        }
      }
      
      return ''; // 未找到匹配的区域码
    } catch (error) {
      console.error('获取区域码失败:', error);
      return '';
    }
  }
  
  // 完整的位置获取流程：权限检查 -> 获取位置 -> 获取区域码
  async getLocationWithAreaCode() {
    try {
      // 获取当前位置
      const position = await this.getCurrentLocation();
      
      // 根据位置获取城市信息和区域码
      const cityInfo = await this.getCityInfoByLocation(
        position.longitude, 
        position.latitude
      );
      var lat = position.latitude;
      var lng = position.longitude;
      localStorage.setItem('currentLocation', JSON.stringify([lng, lat]));
      localStorage.setItem('addressName', cityInfo.cityName);
      localStorage.setItem('addressCode', cityInfo.areaCode)
      return {
        longitude: position.longitude,
        latitude: position.latitude,
        cityName: cityInfo.cityName,
        areaCode: cityInfo.areaCode,
        fullAddress: cityInfo.fullAddress,
        addressComponents: cityInfo.addressComponents
      };
    } catch (error) {
      console.error('获取位置和区域码失败:', error);
      throw error;
    }
  }
}

// 创建并导出单例实例
const locationService = new LocationService();
export default locationService;


// WEBPACK FOOTER //
// ./src/utils/location.js